export default "__VITE_ASSET__f7866be3__"